// libs
import { styled } from '@nykaa/ui-components';

// components
import OverlaySheetBase from 'shared/components/OverlaySheet';
import BaseButton from 'shared/components/Button';

export const OverlaySheet = styled(OverlaySheetBase)`
  width: 100%;
  background-color: #fff;
  top: initial;
  animation-duration: 0.3s;
  border-radius: ${({ theme }) => `${theme.borders.radius40} ${theme.borders.radius40} 0 0`};
  padding: ${({ theme }) =>
    `${theme.spacing.spacing120} ${theme.spacing.spacing100} ${theme.spacing.spacing60} ${theme.spacing.spacing100}`};
`;

export const PrimaryButton = styled(BaseButton)`
  ${({ theme }) => theme.typography.subTitleLarge};
  justify-content: space-between;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
  margin: ${({ theme }) => `${theme.spacing.spacing80} 0`};
  height: 48px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.inverse};
`;
